import { Injectable } from '@angular/core';
import { ClientStockRequest, StockGroup, StockList } from '../models/stock';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class StockService {
  
  apiUrl = 'v1/stock/';

  constructor(private http: HttpClient) {
  
  }

  public getStockList(dataObj: ClientStockRequest) {
    return this.http.post<ClientStockRequest>(environment.apiUrl + `${this.apiUrl}clientstocklist`, dataObj);
  }

  public getStockForIncident(incidentId: number, clientId: number) {
    return this.http.get<StockList>(environment.apiUrl + `${this.apiUrl}incident/${incidentId}/${clientId}`);
  }

  public getStockGroups() {
    return this.http.get<StockGroup[]>(environment.apiUrl + `${this.apiUrl}stockGroup`);
  }

}
